import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ActivityViewDataService } from './../../shared/services/activity-view-data.service';
import { AuthService } from '../../app/services/auth.service';
import { AppHelperService } from 'modules/app/services/app-helper.service';
import { ActivityViewHelperService } from '../../shared/services/activity-view-helper.service';
import { CreateUserAnalyticsService } from './create-user-analytics.service';

@Injectable()
export class LearnerActivityViewResolverService  {
  constructor(private authService: AuthService,
    private activityViewDataService: ActivityViewDataService,
    private appHelperService: AppHelperService,
    private activityViewHelperService: ActivityViewHelperService,
    private createUserAnalyticsService: CreateUserAnalyticsService,
    private router: Router,
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    const spaceId = route.params.spaceId;
    const productCode = route.params.productCode;
    const classId = route.params.classId;
    const folderId = route.params.folderId;
    const assignmentId = route.params.assignmentId;
    const userData = this.authService.getUserData();
    return this.activityViewDataService.getClassActivityViewDataForLearner(spaceId, productCode, classId, assignmentId, folderId).toPromise()
      .then((productData: any) => {
        if (productData && productData.success === false) {
          if(productData.error == 'UA_NOT_PRESENT_ERROR') {
            let redirectRoute = { url: state.url.split('?')[0], queryParams: route.queryParams };
            this.createUserAnalyticsService.setUAMetadata(productData.userId, productData.orgId, productData.pubnubEventType, redirectRoute);
            this.router.navigate(['/learner', route.params.spaceId, 'createUA', 'product', route.params.productCode, 'class', route.params.classId]);
            return;
        }
          this.appHelperService.showLoaderAndNavigateToDashboard();
          return;
        }

        // NEMO-6677 : navigate away to dashboard as the product is suppressed.
        let bundleDetails = productData['bundleDetails'];
        let product = bundleDetails && bundleDetails.products && bundleDetails.products.find((bundle) => bundle['dls-product'] && bundle['dls-product'].code === productCode);
        let suppressedAssignment = assignmentId && this.appHelperService.isProductSuppressed(product, 'hide-assignments', spaceId);
        let suppressedLP = this.appHelperService.isProductSuppressed(product, 'hide-learning-path', spaceId);
        let isAssignmentRoute = (state.url.includes("assignment") || assignmentId);
        if (isAssignmentRoute && suppressedAssignment) {
          this.appHelperService.navigateToDashboardApp([]);
        } else if (!isAssignmentRoute && suppressedLP) {
          this.appHelperService.navigateToDashboardApp([]);
        }

        return {
          'userProfileData': userData,
          'productData': productData
        }
      });
  }
}
